import { render } from "./PostTransplantSectionDetails.vue?vue&type=template&id=714cbc30&scoped=true"
import script from "./PostTransplantSectionDetails.vue?vue&type=script&lang=js"
export * from "./PostTransplantSectionDetails.vue?vue&type=script&lang=js"

import "./PostTransplantSectionDetails.vue?vue&type=style&index=0&id=714cbc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714cbc30"],['__file',"src/components/PostTransplantSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "714cbc30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('714cbc30', __exports__)) {
    api.reload('714cbc30', __exports__)
  }
  
  module.hot.accept("./PostTransplantSectionDetails.vue?vue&type=template&id=714cbc30&scoped=true", () => {
    api.rerender('714cbc30', render)
  })

}


export default __exports__